import { clsx } from 'clsx';

import { Skeleton } from '~/src/common/components/Skeleton/Skeleton';
import { useScreenSize } from '~/src/common/hooks/useScreenSize';

import screenStyles from '../../ProductScreen.module.scss';

import styles from './ProductScreenSkeleton.module.scss';

const ProductScreenSkeleton = () => {
  const size = useScreenSize();

  const imageSize = size.isSmallScreen ? 288 : 368;

  return (
    <div className={screenStyles.container} role="progressbar">
      <Skeleton width="60%" height={16} />

      <div className={screenStyles.content}>
        <div className={screenStyles.grid}>
          <div className={styles.caroussel}>
            <Skeleton className={styles.skeleton} height={80} width={80} />
            <Skeleton height={imageSize} width={imageSize} />
            <Skeleton height={imageSize} width={imageSize} />
          </div>

          <div className={styles.primaryInformation}>
            <Skeleton width={300} height={24} />
            <Skeleton width={150} height={16} />
          </div>

          <div className={clsx(styles.secondaryInformation, screenStyles.asideBlock)}>
            <Skeleton height={64} width={64} />
            <Skeleton height={64} width={64} />
          </div>

          <div className={clsx(styles.picker, screenStyles.asideBlock)}>
            <Skeleton width={80} height={24} />
            <Skeleton height={42} width={135} />
          </div>

          <div className={clsx(styles.shortDescription, screenStyles.asideBlock)}>
            <Skeleton />
            <Skeleton width={100} />
          </div>
        </div>

        <div className={styles.productInformation}>
          <Skeleton width={90} />
          <Skeleton height={60} />
        </div>

        <div className={styles.additionalInformation}>
          <Skeleton width={150} />
          <Skeleton height={600} />
        </div>
      </div>
    </div>
  );
};

export default ProductScreenSkeleton;
